import { useCallback } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Link } from "shared/components";
import { Routes } from "config/navigation";
import { Typography } from "./SwitchToOldDashboardButton.styles";

export const SwitchToOldDashboardButton = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleNavigateToOldDashboard = useCallback(() => {
    navigate(Routes.DASHBOARD_OLD);
  }, [navigate]);

  return (
    <Typography>
      <Trans
        t={t}
        i18nKey="dashboardModule.utils.switchToOldDashboard"
        components={[
          <Link key="navigate" onClick={handleNavigateToOldDashboard} inheritFonts inheritColor />
        ]}
      />
    </Typography>
  );
};
